import React, { useState, useEffect, useContext } from "react";
import ReactStars from "react-rating-stars-component";
import { doc, getDoc } from "firebase/firestore";
import {AuthContext} from '../services/Session/Context';
import moment from "moment"
import {FirebaseContext} from '../services/Firebase/Context';

const FeedbacksItem = ({ date, grade, recordId }) => {
  const { user } = useContext(AuthContext);
  const { db } = useContext(FirebaseContext);
  const [record, setRecord] = useState({});

  useEffect(() => {
    if(!user) return
    const docRef = doc(db, "records", recordId);
    getDoc(docRef).then((doc) => {
      setRecord(doc.data())
    });
  }, [db, user, recordId])
  return (
    <div className="flex items-start mb-6 rounded justify-between">
      <div className="flex items-center w-full justify-between">
        <div className="flex text-sm flex-col w-full ml-2 items-start justify-between">
          <div className="text-gray-700 dark:text-white">
            <span className="font-bold mr-1">
              {record.customerName}{record.customerBusiness && <span className='ml-1 text-yellow-600'>Pro</span> }
            </span>
            a laissé un avis
              <ReactStars
                count={5}
                edit={false}
                size={20}
                value={grade}
                activeColor={(
                  grade >= 4
                  ? "#10B981"
                  : (
                    grade <=2
                    ? "#EF4444"
                    : "#FBBF24"
                  )
                )}
              />
          </div>
          <p className="text-gray-300">
            {date && moment(date.toDate()).calendar()}
          </p>
        </div>
      </div>
    </div>
  );
}

export default FeedbacksItem
